import { Options, Vue } from 'vue-class-component';
import Toggle from '@vueform/toggle';

import * as ContactTypeService from '@/services/contact-type.service';

@Options({
  name: 'contact-type-new',
  components: {
    Toggle,
  },
})
export default class ContactTypeNew extends Vue {
  public errorMessage = '';
  public errors: any = {};
  public hasError = false;
  public row = {
    description: '',
    enabled: true,
  };

  public goBack() {
    this.$router.push('/contact-type');
  }

  public validation() {
    this.errors = {};
    this.hasError = false;

    if (!this.row.description) {
      this.errors.description = 'Este campo deve ser preenchido.';
      this.hasError = true;
    }

    return !this.hasError;
  }

  public save() {
    if (this.validation()) {
      ContactTypeService.insert({
        description: this.row.description,
        enabled: this.row.enabled,
      })
        .then(() => {
          this.$router.push('/contact-type');
        })
        .catch(() => {
          this.errorMessage = 'Ocorreu um erro ao gravar o registro.';
        });
    }
  }
}
